import { Button, Typography, Alert, message } from "antd";
import { AppLogoIcon } from "components/svg-icons";
import { ArrowLeftOutlined, CopyOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router";

const { Title } = Typography;

const SUPPORT_EMAIL = "support@constructiviq.com";

function AccountLocked() {
  const history = useHistory();
  const location = useLocation();
  const emailFromUrl = new URLSearchParams(location.search).get("email") || "";

  const goBackToLogin = () => {
    history.push(`/?email=${encodeURIComponent(emailFromUrl)}`);
  };

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(SUPPORT_EMAIL);
    message.success("Support email copied to clipboard");
  };

  return (
    <div className="login">
      <div className="login-form">
        <div className="flex items-center gap-1 mb-2">
          <Button
            icon={
              <ArrowLeftOutlined style={{ color: "#000000", opacity: "45%" }} />
            }
            className="text-one text-black !bg-transparent !border-0 px-0 !shadow-none"
            onClick={goBackToLogin}
          />
          <div>{emailFromUrl}</div>
        </div>

        <div className="m-auto block">
          <AppLogoIcon />
        </div>

        <div className="flex justify-center mt-2 mb-2">
          <Title level={3}>Account Locked</Title>
        </div>

        <Alert
          type="error"
          showIcon
          message="Due to 5 unsuccessful login attempts, your account has been locked."
          className="mb-4 rounded-lg"
        />

        <div className="pl-2">
          <div className="font-semibold mb-2">To Recover your account:</div>
          <div className="pl-4">
            <ul className="list-disc pl-5 space-y-2 text-gray-700">
              <li>
                Contact customer support at{" "}
                <span className="font-medium">{SUPPORT_EMAIL}</span>
              </li>
              <li>
                Our customer care team will respond to your request within 24
                hours.
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-2">
          <Button
            icon={<CopyOutlined className="text-gray-700" />}
            onClick={handleCopyEmail}
            className="w-full"
            size="large"
          >
            Copy Support Email
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AccountLocked;
